import "./coins.scss";

import CoinCard from "../CoinCard";
import React, { useEffect, useState } from "react";

import { useSelector } from "react-redux";
import moment from "jalali-moment";

import coinTitle from "../../assets/icons/icones moj-04.svg";
import whiteCoinTitle from "../../assets/icons/icones moj-20.svg";
import Spinner from "../Spinner";

const Coins = ({ coins, isLoading }) => {
  const [jalali, setJalali] = useState("");

  const sortedOtherCoins = coins.slice().sort((a, b) => a.id - b.id);

  useEffect(() => {
    const timeSortedCoins = coins
      .slice()
      .sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
    moment.locale("fa", { useGregorianParser: true });
    setJalali(moment(timeSortedCoins[0]?.updatedAt).format("HH:mm YYYY/MM/DD"));
  }, [coins]);

  // store
  const darkThemeFromStore = useSelector(
    (state) =>
      // console.log(state);
      state.Reducer.darkTheme
  );

  return (
    <div
      className={`coins-rate ${isLoading ? "h-isloading" : ""} ${
        darkThemeFromStore ? "dark-back" : ""
      }`}
    >
      <div className="title">
        <img
          src={darkThemeFromStore ? whiteCoinTitle : coinTitle}
          alt="نرخ سکه"
        />
        <h1>نرخ سکه</h1>
        <div className="latest-update mx-3 text-sm border-2 rounded-md px-1">{jalali}</div>
      </div>
      {isLoading ? (
        <Spinner isDark={true} />
      ) : (
        <div className="coins-container">
          <div
            className={`coins-section ${darkThemeFromStore ? "br-white" : ""}`}
          >
            {sortedOtherCoins?.map((coin) => {
              return <CoinCard key={coin.id} coin={coin} />;
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default Coins;
